let sharedMeasureContext: CanvasRenderingContext2D | null = null

export function getMeasureContext(): CanvasRenderingContext2D | null {
  if (!sharedMeasureContext) {
    sharedMeasureContext = document.createElement('canvas').getContext('2d')
  }
  return sharedMeasureContext
}

export function truncateByCharacterCount(
  text: string,
  maxLength: number
): { displayText: string; isTruncated: boolean } {
  if (text.length <= maxLength) {
    return { displayText: text, isTruncated: false }
  }
  const startLength = Math.floor((maxLength - 3) / 2)
  const endLength = Math.ceil((maxLength - 3) / 2)
  return {
    displayText: `${text.substring(0, startLength)}...${text.substring(text.length - endLength)}`,
    isTruncated: true,
  }
}

export function truncateMiddleToWidth(
  text: string,
  containerWidth: number,
  measure: (value: string) => number
): { displayText: string; isTruncated: boolean } {
  const fitWidth = containerWidth - 1
  if (measure(text) <= fitWidth) {
    return { displayText: text, isTruncated: false }
  }
  const ellipsis = '...'
  const availableWidth = fitWidth - measure(ellipsis)
  let low = 0
  let high = text.length
  let bestLength = 0
  while (low <= high) {
    const mid = Math.floor((low + high) / 2)
    const startLen = Math.floor(mid / 2)
    const endLen = Math.ceil(mid / 2)
    const testText =
      text.substring(0, startLen) + text.substring(text.length - endLen)
    if (measure(testText) <= availableWidth) {
      bestLength = mid
      low = mid + 1
    } else {
      high = mid - 1
    }
  }
  if (bestLength < 2) {
    return { displayText: ellipsis, isTruncated: true }
  }
  const startLen = Math.floor(bestLength / 2)
  const endLen = Math.ceil(bestLength / 2)
  return {
    displayText: `${text.substring(0, startLen)}${ellipsis}${text.substring(text.length - endLen)}`,
    isTruncated: true,
  }
}
